export const preserveOpenModalState = (current, next, openModal) => {
  const modalCode = current?.triggerModal?.[openModal]
  if (!modalCode) return next

  return {
    ...next,
    triggerModal: {
      ...next?.triggerModal,
      [openModal]: modalCode,
    },
    modal: {
      ...next?.modal,
      [modalCode]: current.modal?.[modalCode],
    },
  }
}
